import _ from 'lodash';

const encodeGeonameAirportObj = (geoname) => _.pick(geoname, ['airportCode', 'label']);

export default encodeGeonameAirportObj;
